const DEFAULT_PRIVACY_SETTINGS = Object.freeze({
  hideEmail: false,
  hideAge: false,
  cityOnly: true,
  visibleOnMap: true,
  nearbySuggestions: true,
  // Sorties auxquelles je suis inscrit, visibles sur mon profil.
  showParticipations: true,
});

// N06 : chaque préférence de notification est un objet {inApp, email, push}
// piloté indépendamment par canal (aligné sur functions/src/domain/userSettings.js).
const ALL_CHANNELS_ON = Object.freeze({ inApp: true, email: true, push: true });

const DEFAULT_NOTIFICATION_SETTINGS = Object.freeze({
  eventReminders: ALL_CHANNELS_ON,
  nearbyEvents: ALL_CHANNELS_ON,
  messages: ALL_CHANNELS_ON,
  profileActivity: ALL_CHANNELS_ON,
  activity: ALL_CHANNELS_ON,
  organizerNews: ALL_CHANNELS_ON,
  // ADR-016 : nouvelles sorties de membres proches. « acquaintanceEvents »
  // n'a volontairement pas de valeur par defaut : absent, il suit nearbyEvents.
  localEvents: ALL_CHANNELS_ON,
});

// ADR-016 : preference affichee et modifiee a partir d'une autre tant que le
// membre ne l'a pas choisie (aligne sur PREF_FALLBACK_KEY cote serveur).
export const NOTIFICATION_PREF_FALLBACK_KEYS = Object.freeze({
  acquaintanceEvents: "nearbyEvents",
});

const DEFAULT_APP_SETTINGS = Object.freeze({
  language: "fr",
  reducedMotion: false,
});

export const DEFAULT_USER_SETTINGS = Object.freeze({
  privacy: DEFAULT_PRIVACY_SETTINGS,
  notifications: DEFAULT_NOTIFICATION_SETTINGS,
  app: DEFAULT_APP_SETTINGS,
});

function normalizePlainObject(value) {
  return value && Object.getPrototypeOf(value) === Object.prototype ? value : {};
}

export function createDefaultUserSettings() {
  return {
    privacy: { ...DEFAULT_PRIVACY_SETTINGS },
    notifications: { ...DEFAULT_NOTIFICATION_SETTINGS },
    app: { ...DEFAULT_APP_SETTINGS },
  };
}

export function mergeUserSettings(value) {
  const nextSettings = normalizePlainObject(value);

  return {
    privacy: {
      ...DEFAULT_PRIVACY_SETTINGS,
      ...normalizePlainObject(nextSettings.privacy),
    },
    notifications: {
      ...DEFAULT_NOTIFICATION_SETTINGS,
      ...normalizePlainObject(nextSettings.notifications),
    },
    app: {
      ...DEFAULT_APP_SETTINGS,
      ...normalizePlainObject(nextSettings.app),
    },
  };
}
